import { render, staticRenderFns } from "./ModalDeletePortfolio.vue?vue&type=template&id=711cdf0e&"
import script from "./ModalDeletePortfolio.vue?vue&type=script&lang=js&"
export * from "./ModalDeletePortfolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports